export const singleCheckboxTemplate = (ctx: any) => {
  return `<div class="form-check checkbox custom-control custom-checkbox">
  <label class="${ctx.input.labelClass} form-check-label custom-radio-label">
    <${ctx.input.type}
      ref="input"
      ${(function () {
        let r = "";
        for (const attr in ctx.input.attr) {
          if (attr === "class") {
            r += `${attr}="${ctx.input.attr[attr]} custom-control-input"`;
            break;
          }
          r += `${attr}="${ctx.input.attr[attr]}"`;
        }
        return r;
      })()}
      ${ctx.checked ? "checked=true" : ""}
      aria-required="${ctx.component.validate.required}"
      ${
        ctx.component.description
          ? `aria-describedby="d-${ctx.instance.id}-${ctx.component.key}"`
          : ""
      }
      >
    <div class="custom-outer-box"><div class="custom-inner-box"></div></div>
    ${
      !ctx.self.labelIsHidden()
        ? `<span class="checkbox-text">${ctx.input.label}</span>`
        : ""
    }
    ${ctx.input.content ? ctx.input.content : ""}
    </${ctx.input.type}>
  </label>
  ${
    ctx.component.tooltip
      ? `<i ref="tooltip" tabindex="0" class="${ctx.iconClass(
          "question-sign"
        )} text-muted" data-tooltip="${ctx.component.tooltip}"></i>`
      : ""
  }
</div>`;
};
